// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ind-container {
  container-type: inline-size;
  width: 100%;
  min-width: 100%;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  overflow-x: hidden;
}

.ind-container .ind-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.ind-container .ind-table thead th {
  height: 32px;
  border-bottom: 1px solid var(--border-line);
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 8px;
  text-align: right;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-subheader);
  vertical-align: bottom;
}
.ind-container .ind-table thead th:first-child {
  border: none;
}

.ind-container .ind-table thead th .ind-th-cell {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
}

.ind-container .ind-table thead th .ind-th-cell.align-left {
  justify-content: flex-start;
  text-align: left;
}

.ind-container .ind-table thead th .ind-th-cell.align-right {
  justify-content: flex-end;
  text-align: right;
}

.ind-container .ind-table thead th .ind-th-label {
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.ind-container .ind-table thead th.no {
  text-align: center;
  width: 8px;
  padding-right: 8px;
}

.ind-container .ind-table thead th.ctry {
  width: 28px;
  min-width: 28px;
  padding-right: 8px;
}

.ind-container .ind-table thead th.ticker {
  text-align: left;
  width: 62px;
  min-width: 62px;
  padding-right: 8px;
}

.ind-container .ind-table thead th.name {
  text-align: left;
  min-width: 150px;
}

.ind-container .ind-table thead th.tickerName {
  text-align: left;
}

.ind-container .ind-table thead th.perf1D,
.ind-container .ind-table thead th.perf1M,
.ind-container .ind-table thead th.perf3M,
.ind-container .ind-table thead th.perf6M,
.ind-container .ind-table thead th.perf1Y {
  text-align: right;
}

.ind-container .ind-table thead th:last-child,
.ind-container .ind-table tbody td:last-child {
  width: 32px;
  min-width: 32px;
  max-width: 32px;
  padding-left: 0px;
  padding-right: 0px;
  border: none;
}

.ind-container .ind-table thead th.sortable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
  min-width: 80px;
}

.ind-container .ind-table thead th.sortable svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  display: inline-block;
  vertical-align: middle;
  transition: transform 0.2s ease;
}

.ind-container .ind-table tbody tr {
  vertical-align: middle;
}
.ind-container .ind-table tbody tr:nth-child(2n) {
  background-color: var(--row-dark);
}

.ind-container .ind-table tbody td {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  vertical-align: middle;
  height: 56px;
  box-sizing: border-box;
}
.ind-container .ind-table tbody td:first-child {
  width: 30px;
  max-width: 30px;
}

.ind-container .ind-table tbody td.no {
  text-align: justify;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text-primary);
  padding-right: 8px;
}

.ind-container .ind-table tbody td.ctry {
  text-align: left;
  width: 28px;
  max-width: 28px;
}

.ind-container .ind-table tbody td.ctry svg {
  width: 20px;
  height: 20px;
}

.ind-container .ind-table tbody td.ticker {
  text-align: left;
  text-decoration: underline;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
  padding-right: 8px;
}

.ind-container .ind-table tbody td.name {
  text-align: left;
  text-decoration: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
}

.ind-container .ind-table tbody td.tickerName {
  text-align: left;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ind-container .ind-table tbody td.tickerName .ticker {
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

.ind-container .ind-table tbody td.tickerName .name {
  text-align: left;
  letter-spacing: 0;
  color: var(--text-primary);
  padding-right: 8px;
}

.ind-container .ind-table tbody td.last {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  min-width: 77px;
  padding-right: 8px;
}

.ind-container .ind-table tbody td.noborder {
  border: none;
  color: var(--text-secondary);
}

.ind-container .ind-table tbody td.nochange {
  color: var(--text-unchg-color);
}

.ind-container .ind-table tbody td.positive {
  color: var(--text-up-color);
}

.ind-container .ind-table tbody td.negative-small {
  color: var(--text-subheader);
}

.ind-container .ind-table tbody td.negative {
  color: var(--text-down-color);
}

.ind-container .ind-table tbody td.perf1D,
.ind-container .ind-table tbody td.perf1M,
.ind-container .ind-table tbody td.perf3M,
.ind-container .ind-table tbody td.perf6M,
.ind-container .ind-table tbody td.perf1Y {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  height: 40px;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 8px;
  box-sizing: border-box;
}

.ind-container .ind-table tbody td.lastcolumn {
  width: 0;
  border: none;
}

.ind-container .ind-table tfoot td {
  height: 52px;
  padding-left: 24px;
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-primary);
}

.ind-container .rec-strong-buy {
  background-color: var(--heatmap-up-2);
  color: var(--text-invert);
}

.ind-container .ind-table tbody td.last {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  min-width: 77px;
  padding-right: 8px;
}

.ind-container .ind-table tbody td.noborder {
  border: none;
}

.ind-container .ind-table tbody td.perf1D {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  min-width: 120px;
  padding-right: 8px;
  max-height: 56px;
}
.ind-container .ind-table tbody td.perf1M {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  min-width: 120px;
  padding-right: 8px;
  max-height: 56px;
}

.ind-container .ind-table tbody td.perf3M {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  min-width: 120px;
  padding-right: 8px;
  max-height: 56px;
}

.ind-container .ind-table tbody td.perf6M {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  min-width: 120px;
  padding-right: 8px;
  max-height: 56px;
}

.ind-container .ind-table tbody td.perf1Y {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  height: 40px;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 8px;
  box-sizing: border-box;
}

.ind-container .ind-table tbody td.lastcolumn {
  width: 0;
  border: none;
}

.ind-container .ind-table tfoot td {
  height: 52px;
  padding-left: 24px;
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-primary);
}

.ind-container .rec-strong-buy {
  background-color: var(--heatmap-up-5);
  color: var(--text-invert);
}

.ind-container .rec-buy {
  background-color: var(--heatmap-up-4);
  color: var(--text-invert);
}

.ind-container .rec-hold {
  background-color: var(--surface-secondary);
  color: var(--text-primary);
}

.ind-container .rec-reduce {
  background-color: var(--heatmap-down-4);
  color: var(--text-invert);
}

.ind-container .rec-sell {
  background-color: var(--heatmap-down-6);
  color: var(--text-invert);
}

.ind-container .ind-whitespace {
  height: 24px;
}

.ind-container .ind-pagination {
  padding: 32px;
  background-color: var(--surface-secondary);
}

.ind-container .alignRight {
  text-align: right;
}

.ind-container .alignCenter {
  text-align: center;
}

.ind-container .ind-tbl-cel-flex-container {
  display: flex;
  align-items: center;
  max-width: 90%;
}

.ind-container .ind-tbl-cel-flex-container.ticker {
  margin-right: 8px;
}

.ind-container .ind-tbl-cel-text {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}

.ind-container .ind-tbl-cel-ticker {
  flex: 0 0 50px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-ticker);
  font-weight: 700;
}

.ind-container .ind-tbl-cel-name {
  text-decoration: none;
  display: inline-block;
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-instrument);
}

@container (min-width: 768px) {
  .ind-container .ind-table thead th.perf1D,
  .ind-container .ind-table thead th.perf1M,
  .ind-container .ind-table thead th.perf3M,
  .ind-container .ind-table thead th.perf6M,
  .ind-container .ind-table thead th.perf1Y {
    padding-right: 8px;
    text-align: right;
  }

  .ind-container .ind-table tbody td {
    height: 40px;
  }

  .ind-container .ind-table tbody td.perf1D,
  .ind-container .ind-table tbody td.perf1M,
  .ind-container .ind-table tbody td.perf3M,
  .ind-container .ind-table tbody td.perf6M,
  .ind-container .ind-table tbody td.perf1Y {
    width: 10%;
    min-width: 110px;
    text-align: right;
    border: 1px solid var(--surface-primary);
  }

  .ind-container .ind-table thead th.ctry,
  .ind-container .ind-table tbody td.ctry {
    padding-right: 16px;
  }

  .ind-container .ind-tbl-cel-name {
    margin-left: 12px;
  }

  .ind-container .ind-tbl-cel-flex-container {
    max-width: 100%;
  }

  .ind-container .ind-tbl-cel-text {
    width: 100%;
  }

  .ind-container .ind-table tbody td.tickerName,
  .ind-container .ind-table thead th.tickerName,
  .ind-container .ind-table tbody td.name,
  .ind-container .ind-table thead th.name {
    max-width: 130px;
    width: 130px;
  }

  .ind-container .ind-table tbody td.tickerName .ticker,
  .ind-container .ind-table tbody td.tickerName .name,
  .ind-container .ind-table tbody td.name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}

@container (min-width: 768px) and (max-width: 1023px) {
  .ind-container .ind-table tbody td.perf1D,
  .ind-container .ind-table tbody td.perf1M,
  .ind-container .ind-table tbody td.perf3M,
  .ind-container .ind-table tbody td.perf6M,
  .ind-container .ind-table tbody td.perf1Y {
    min-width: 85px;

    padding-right: 8px;
  }
}

@container (min-width: 1024px) {
  .ind-container .ind-table tbody td.perf1D,
  .ind-container .ind-table tbody td.perf1M,
  .ind-container .ind-table tbody td.perf3M,
  .ind-container .ind-table tbody td.perf6M,
  .ind-container .ind-table tbody td.perf1Y {
    min-width: 110px;
  }

  .ind-container .ind-table tbody td.tickerName,
  .ind-container .ind-table thead th.tickerName,
  .ind-container .ind-table thead th.name,
  .ind-container .ind-table tbody td.name {
    max-width: 350px;
  }
}

@container (min-width: 1440px) {
  .ind-container .ind-table tbody td.tickerName,
  .ind-container .ind-table thead th.tickerName,
  .ind-container .ind-table thead th.name,
  .ind-container .ind-table tbody td.name {
    max-width: 550px;
  }
}

@container (min-width: 768px) {
  .ind-container .ind-table thead th:first-child,
  .ind-container .ind-table tbody td:first-child {
    width: 32px;
    min-width: 32px;
    max-width: 32px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .ind-container .ind-table thead th.ctry,
  .ind-container .ind-table tbody td.ctry {
    padding-left: 0px;
    padding-right: 16px;
  }

  .ind-container .ind-table tbody td {
    height: 40px;
  }

  .ind-container .ind-table tbody td.perf1D,
  .ind-container .ind-table tbody td.perf1M,
  .ind-container .ind-table tbody td.perf3M,
  .ind-container .ind-table tbody td.perf6M,
  .ind-container .ind-table tbody td.perf1Y {
    width: 8%;
    min-width: 80px;
  }

  .ind-container .ind-tbl-cel-flex-container {
    max-width: 100%;
  }

  .ind-container .ind-tbl-cel-text {
    width: 100%;
  }

  .ind-container .ind-table tbody td.tickerName,
  .ind-container .ind-table thead th.tickerName,
  .ind-container .ind-table tbody td.name,
  .ind-container .ind-table thead th.name {
    max-width: 130px;
    width: 130px;
  }

  .ind-container .ind-table tbody td.tickerName .ticker,
  .ind-container .ind-table tbody td.tickerName .name,
  .ind-container .ind-table tbody td.name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}

@container (max-width: 767px) {
  .ind-container .ind-table tbody td.perf1D,
  .ind-container .ind-table tbody td.perf1M,
  .ind-container .ind-table tbody td.perf3M,
  .ind-container .ind-table tbody td.perf6M,
  .ind-container .ind-table tbody td.perf1Y {
    min-width: unset;
  }

  .ind-container .ind-table thead th:last-child,
  .ind-container .ind-table tbody td:last-child,
  .ind-container .ind-table tbody td.lastcolumn {
    width: 16px;
    min-width: 16px;
    max-width: 16px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .ind-container .ind-table thead th:first-child,
  .ind-container .ind-table tbody td:first-child {
    width: 16px;
    min-width: 16px;
    max-width: 16px;
    padding: 0px;
  }

  .ind-container .ind-table tbody td.ctry {
    padding-left: 0px;
    padding-right: 0px;
  }

  .ind-container .ind-table thead th.tickerName,
  .ind-container .ind-table tbody td.tickerName {
    padding-left: 8px;
  }

  .ind-container .ind-table tbody td.tickerName {
    display: table-cell;
    max-width: 0;
    width: 100%;
  }

  .ind-container .ind-table tbody td.tickerName.tickerName .ticker,
  .ind-container .ind-table tbody td.tickerName.tickerName .name {
    display: block;
    width: 100%;

    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ind-container .ind-table tbody td.tickerName .ind-tbl-cel-flex-container {
    overflow: hidden;
  }

  .ind-container .ind-table tbody td.tickerName .ind-tbl-cel-text {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }

  .ind-container .ind-table tbody td.tickerName .ind-tbl-cel-text span {
    display: inline;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@container (min-width:1200px) {
  .ind-container .ind-table tbody td.perf1D,
  .ind-container .ind-table tbody td.perf1M,
  .ind-container .ind-table tbody td.perf3M,
  .ind-container .ind-table tbody td.perf6M,
  .ind-container .ind-table tbody td.perf1Y {
    width: 8%;
    min-width: 120px;
  }
}
.sort-icon-asc path,
.sort-icon-desc path {
  fill: var(--color-brand);
}

.ind-container .ind-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 32px;
  padding: 0 8px;
  border-bottom: 1px solid var(--border-line);
  box-sizing: border-box;
}

.ind-container .ind-list-header .ind-list-name,
.ind-container .ind-list-header .ind-list-perf {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-subheader);
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.ind-container .ind-list-header .ind-list-perf {
  justify-content: flex-end;
}

.ind-container .ind-list-name.sortable,
.ind-container .ind-list-perf.sortable {
  cursor: pointer;
  user-select: none;
}

.ind-container .ind-list-name.sortable svg,
.ind-container .ind-list-perf.sortable svg {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
  transition: transform 0.2s ease;
}

.ind-container .ind-list-body .ind-list-row:nth-child(2n) {
  background-color: var(--row-dark);
}

.ind-container .ind-list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 40px;
  padding: 8px;
  box-sizing: border-box;
}

.ind-container .ind-list-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
}

.ind-container .ind-list-ctry {
  flex: none;
  display: inline-flex;
}

.ind-container .ind-list-ctry svg {
  width: 20px;
  height: 20px;
}

.ind-container .ind-list-name {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--text-ticker);
  cursor: pointer;
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.ind-container .ind-list-name .ind-tbl-cel-flex-container {
  max-width: 100%;
  width: 100%;
}

.ind-container .ind-list-name.highlighted {
  font-weight: bold !important;
}

.ind-container .ind-list-perf {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-secondary);
  white-space: nowrap;
  flex: none;
}

.ind-container .ind-list-perf.nochange {
  color: var(--text-unchg-color);
}

.ind-container .ind-list-perf.positive {
  color: var(--text-up-color);
}

.ind-container .ind-list-perf.negative,
.ind-container .ind-list-perf.negative-small {
  color: var(--text-down-color);
}

.ind-container .ind-list-no-data {
  padding: 16px 8px;
  text-align: center;
  color: var(--text-secondary);
}

.ind-container .ind-list-footer {
  padding: 16px 8px;
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/IndicesWidget/IndicesWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,+CAA+C;EAC/C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE;;;;;IAKE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;;;;;IAKE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;EAC1C;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;IAIE,gBAAgB;IAChB,YAAY;EACd;;EAEA;;;IAGE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE;;;;;IAKE,eAAe;;IAEf,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;;IAKE,gBAAgB;EAClB;;EAEA;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;;;;;IAKE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;IAIE,gBAAgB;IAChB,YAAY;EACd;;EAEA;;;IAGE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE;;;;;IAKE,gBAAgB;EAClB;;EAEA;;;IAGE,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,cAAc;IACd,WAAW;;IAEX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;;;;;IAKE,SAAS;IACT,gBAAgB;EAClB;AACF;AACA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":[".ind-container {\n  container-type: inline-size;\n  width: 100%;\n  min-width: 100%;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  overflow-x: hidden;\n}\n\n.ind-container .ind-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.ind-container .ind-table thead th {\n  height: 32px;\n  border-bottom: 1px solid var(--border-line);\n  box-sizing: border-box;\n  padding-top: 0;\n  padding-bottom: 8px;\n  text-align: right;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  vertical-align: bottom;\n}\n.ind-container .ind-table thead th:first-child {\n  border: none;\n}\n\n.ind-container .ind-table thead th .ind-th-cell {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  min-width: 0;\n}\n\n.ind-container .ind-table thead th .ind-th-cell.align-left {\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.ind-container .ind-table thead th .ind-th-cell.align-right {\n  justify-content: flex-end;\n  text-align: right;\n}\n\n.ind-container .ind-table thead th .ind-th-label {\n  min-width: 0;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.ind-container .ind-table thead th.no {\n  text-align: center;\n  width: 8px;\n  padding-right: 8px;\n}\n\n.ind-container .ind-table thead th.ctry {\n  width: 28px;\n  min-width: 28px;\n  padding-right: 8px;\n}\n\n.ind-container .ind-table thead th.ticker {\n  text-align: left;\n  width: 62px;\n  min-width: 62px;\n  padding-right: 8px;\n}\n\n.ind-container .ind-table thead th.name {\n  text-align: left;\n  min-width: 150px;\n}\n\n.ind-container .ind-table thead th.tickerName {\n  text-align: left;\n}\n\n.ind-container .ind-table thead th.perf1D,\n.ind-container .ind-table thead th.perf1M,\n.ind-container .ind-table thead th.perf3M,\n.ind-container .ind-table thead th.perf6M,\n.ind-container .ind-table thead th.perf1Y {\n  text-align: right;\n}\n\n.ind-container .ind-table thead th:last-child,\n.ind-container .ind-table tbody td:last-child {\n  width: 32px;\n  min-width: 32px;\n  max-width: 32px;\n  padding-left: 0px;\n  padding-right: 0px;\n  border: none;\n}\n\n.ind-container .ind-table thead th.sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n  min-width: 80px;\n}\n\n.ind-container .ind-table thead th.sortable svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  display: inline-block;\n  vertical-align: middle;\n  transition: transform 0.2s ease;\n}\n\n.ind-container .ind-table tbody tr {\n  vertical-align: middle;\n}\n.ind-container .ind-table tbody tr:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.ind-container .ind-table tbody td {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  vertical-align: middle;\n  height: 56px;\n  box-sizing: border-box;\n}\n.ind-container .ind-table tbody td:first-child {\n  width: 30px;\n  max-width: 30px;\n}\n\n.ind-container .ind-table tbody td.no {\n  text-align: justify;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  padding-right: 8px;\n}\n\n.ind-container .ind-table tbody td.ctry {\n  text-align: left;\n  width: 28px;\n  max-width: 28px;\n}\n\n.ind-container .ind-table tbody td.ctry svg {\n  width: 20px;\n  height: 20px;\n}\n\n.ind-container .ind-table tbody td.ticker {\n  text-align: left;\n  text-decoration: underline;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n  padding-right: 8px;\n}\n\n.ind-container .ind-table tbody td.name {\n  text-align: left;\n  text-decoration: none;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n}\n\n.ind-container .ind-table tbody td.tickerName {\n  text-align: left;\n  padding-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ind-container .ind-table tbody td.tickerName .ticker {\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.ind-container .ind-table tbody td.tickerName .name {\n  text-align: left;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  padding-right: 8px;\n}\n\n.ind-container .ind-table tbody td.last {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  min-width: 77px;\n  padding-right: 8px;\n}\n\n.ind-container .ind-table tbody td.noborder {\n  border: none;\n  color: var(--text-secondary);\n}\n\n.ind-container .ind-table tbody td.nochange {\n  color: var(--text-unchg-color);\n}\n\n.ind-container .ind-table tbody td.positive {\n  color: var(--text-up-color);\n}\n\n.ind-container .ind-table tbody td.negative-small {\n  color: var(--text-subheader);\n}\n\n.ind-container .ind-table tbody td.negative {\n  color: var(--text-down-color);\n}\n\n.ind-container .ind-table tbody td.perf1D,\n.ind-container .ind-table tbody td.perf1M,\n.ind-container .ind-table tbody td.perf3M,\n.ind-container .ind-table tbody td.perf6M,\n.ind-container .ind-table tbody td.perf1Y {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  height: 40px;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-right: 8px;\n  box-sizing: border-box;\n}\n\n.ind-container .ind-table tbody td.lastcolumn {\n  width: 0;\n  border: none;\n}\n\n.ind-container .ind-table tfoot td {\n  height: 52px;\n  padding-left: 24px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n\n.ind-container .rec-strong-buy {\n  background-color: var(--heatmap-up-2);\n  color: var(--text-invert);\n}\n\n.ind-container .ind-table tbody td.last {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  min-width: 77px;\n  padding-right: 8px;\n}\n\n.ind-container .ind-table tbody td.noborder {\n  border: none;\n}\n\n.ind-container .ind-table tbody td.perf1D {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  min-width: 120px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n.ind-container .ind-table tbody td.perf1M {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  min-width: 120px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n\n.ind-container .ind-table tbody td.perf3M {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  min-width: 120px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n\n.ind-container .ind-table tbody td.perf6M {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  min-width: 120px;\n  padding-right: 8px;\n  max-height: 56px;\n}\n\n.ind-container .ind-table tbody td.perf1Y {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  height: 40px;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-right: 8px;\n  box-sizing: border-box;\n}\n\n.ind-container .ind-table tbody td.lastcolumn {\n  width: 0;\n  border: none;\n}\n\n.ind-container .ind-table tfoot td {\n  height: 52px;\n  padding-left: 24px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n\n.ind-container .rec-strong-buy {\n  background-color: var(--heatmap-up-5);\n  color: var(--text-invert);\n}\n\n.ind-container .rec-buy {\n  background-color: var(--heatmap-up-4);\n  color: var(--text-invert);\n}\n\n.ind-container .rec-hold {\n  background-color: var(--surface-secondary);\n  color: var(--text-primary);\n}\n\n.ind-container .rec-reduce {\n  background-color: var(--heatmap-down-4);\n  color: var(--text-invert);\n}\n\n.ind-container .rec-sell {\n  background-color: var(--heatmap-down-6);\n  color: var(--text-invert);\n}\n\n.ind-container .ind-whitespace {\n  height: 24px;\n}\n\n.ind-container .ind-pagination {\n  padding: 32px;\n  background-color: var(--surface-secondary);\n}\n\n.ind-container .alignRight {\n  text-align: right;\n}\n\n.ind-container .alignCenter {\n  text-align: center;\n}\n\n.ind-container .ind-tbl-cel-flex-container {\n  display: flex;\n  align-items: center;\n  max-width: 90%;\n}\n\n.ind-container .ind-tbl-cel-flex-container.ticker {\n  margin-right: 8px;\n}\n\n.ind-container .ind-tbl-cel-text {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-decoration: none;\n}\n\n.ind-container .ind-tbl-cel-ticker {\n  flex: 0 0 50px;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--text-ticker);\n  font-weight: 700;\n}\n\n.ind-container .ind-tbl-cel-name {\n  text-decoration: none;\n  display: inline-block;\n  width: 80%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--text-instrument);\n}\n\n@container (min-width: 768px) {\n  .ind-container .ind-table thead th.perf1D,\n  .ind-container .ind-table thead th.perf1M,\n  .ind-container .ind-table thead th.perf3M,\n  .ind-container .ind-table thead th.perf6M,\n  .ind-container .ind-table thead th.perf1Y {\n    padding-right: 8px;\n    text-align: right;\n  }\n\n  .ind-container .ind-table tbody td {\n    height: 40px;\n  }\n\n  .ind-container .ind-table tbody td.perf1D,\n  .ind-container .ind-table tbody td.perf1M,\n  .ind-container .ind-table tbody td.perf3M,\n  .ind-container .ind-table tbody td.perf6M,\n  .ind-container .ind-table tbody td.perf1Y {\n    width: 10%;\n    min-width: 110px;\n    text-align: right;\n    border: 1px solid var(--surface-primary);\n  }\n\n  .ind-container .ind-table thead th.ctry,\n  .ind-container .ind-table tbody td.ctry {\n    padding-right: 16px;\n  }\n\n  .ind-container .ind-tbl-cel-name {\n    margin-left: 12px;\n  }\n\n  .ind-container .ind-tbl-cel-flex-container {\n    max-width: 100%;\n  }\n\n  .ind-container .ind-tbl-cel-text {\n    width: 100%;\n  }\n\n  .ind-container .ind-table tbody td.tickerName,\n  .ind-container .ind-table thead th.tickerName,\n  .ind-container .ind-table tbody td.name,\n  .ind-container .ind-table thead th.name {\n    max-width: 130px;\n    width: 130px;\n  }\n\n  .ind-container .ind-table tbody td.tickerName .ticker,\n  .ind-container .ind-table tbody td.tickerName .name,\n  .ind-container .ind-table tbody td.name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n}\n\n@container (min-width: 768px) and (max-width: 1023px) {\n  .ind-container .ind-table tbody td.perf1D,\n  .ind-container .ind-table tbody td.perf1M,\n  .ind-container .ind-table tbody td.perf3M,\n  .ind-container .ind-table tbody td.perf6M,\n  .ind-container .ind-table tbody td.perf1Y {\n    min-width: 85px;\n\n    padding-right: 8px;\n  }\n}\n\n@container (min-width: 1024px) {\n  .ind-container .ind-table tbody td.perf1D,\n  .ind-container .ind-table tbody td.perf1M,\n  .ind-container .ind-table tbody td.perf3M,\n  .ind-container .ind-table tbody td.perf6M,\n  .ind-container .ind-table tbody td.perf1Y {\n    min-width: 110px;\n  }\n\n  .ind-container .ind-table tbody td.tickerName,\n  .ind-container .ind-table thead th.tickerName,\n  .ind-container .ind-table thead th.name,\n  .ind-container .ind-table tbody td.name {\n    max-width: 350px;\n  }\n}\n\n@container (min-width: 1440px) {\n  .ind-container .ind-table tbody td.tickerName,\n  .ind-container .ind-table thead th.tickerName,\n  .ind-container .ind-table thead th.name,\n  .ind-container .ind-table tbody td.name {\n    max-width: 550px;\n  }\n}\n\n@container (min-width: 768px) {\n  .ind-container .ind-table thead th:first-child,\n  .ind-container .ind-table tbody td:first-child {\n    width: 32px;\n    min-width: 32px;\n    max-width: 32px;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .ind-container .ind-table thead th.ctry,\n  .ind-container .ind-table tbody td.ctry {\n    padding-left: 0px;\n    padding-right: 16px;\n  }\n\n  .ind-container .ind-table tbody td {\n    height: 40px;\n  }\n\n  .ind-container .ind-table tbody td.perf1D,\n  .ind-container .ind-table tbody td.perf1M,\n  .ind-container .ind-table tbody td.perf3M,\n  .ind-container .ind-table tbody td.perf6M,\n  .ind-container .ind-table tbody td.perf1Y {\n    width: 8%;\n    min-width: 80px;\n  }\n\n  .ind-container .ind-tbl-cel-flex-container {\n    max-width: 100%;\n  }\n\n  .ind-container .ind-tbl-cel-text {\n    width: 100%;\n  }\n\n  .ind-container .ind-table tbody td.tickerName,\n  .ind-container .ind-table thead th.tickerName,\n  .ind-container .ind-table tbody td.name,\n  .ind-container .ind-table thead th.name {\n    max-width: 130px;\n    width: 130px;\n  }\n\n  .ind-container .ind-table tbody td.tickerName .ticker,\n  .ind-container .ind-table tbody td.tickerName .name,\n  .ind-container .ind-table tbody td.name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n  }\n}\n\n@container (max-width: 767px) {\n  .ind-container .ind-table tbody td.perf1D,\n  .ind-container .ind-table tbody td.perf1M,\n  .ind-container .ind-table tbody td.perf3M,\n  .ind-container .ind-table tbody td.perf6M,\n  .ind-container .ind-table tbody td.perf1Y {\n    min-width: unset;\n  }\n\n  .ind-container .ind-table thead th:last-child,\n  .ind-container .ind-table tbody td:last-child,\n  .ind-container .ind-table tbody td.lastcolumn {\n    width: 16px;\n    min-width: 16px;\n    max-width: 16px;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .ind-container .ind-table thead th:first-child,\n  .ind-container .ind-table tbody td:first-child {\n    width: 16px;\n    min-width: 16px;\n    max-width: 16px;\n    padding: 0px;\n  }\n\n  .ind-container .ind-table tbody td.ctry {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .ind-container .ind-table thead th.tickerName,\n  .ind-container .ind-table tbody td.tickerName {\n    padding-left: 8px;\n  }\n\n  .ind-container .ind-table tbody td.tickerName {\n    display: table-cell;\n    max-width: 0;\n    width: 100%;\n  }\n\n  .ind-container .ind-table tbody td.tickerName.tickerName .ticker,\n  .ind-container .ind-table tbody td.tickerName.tickerName .name {\n    display: block;\n    width: 100%;\n\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .ind-container .ind-table tbody td.tickerName .ind-tbl-cel-flex-container {\n    overflow: hidden;\n  }\n\n  .ind-container .ind-table tbody td.tickerName .ind-tbl-cel-text {\n    flex: 1;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    display: block;\n  }\n\n  .ind-container .ind-table tbody td.tickerName .ind-tbl-cel-text span {\n    display: inline;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n@container (min-width:1200px) {\n  .ind-container .ind-table tbody td.perf1D,\n  .ind-container .ind-table tbody td.perf1M,\n  .ind-container .ind-table tbody td.perf3M,\n  .ind-container .ind-table tbody td.perf6M,\n  .ind-container .ind-table tbody td.perf1Y {\n    width: 8%;\n    min-width: 120px;\n  }\n}\n.sort-icon-asc path,\n.sort-icon-desc path {\n  fill: var(--color-brand);\n}\n\n.ind-container .ind-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  height: 32px;\n  padding: 0 8px;\n  border-bottom: 1px solid var(--border-line);\n  box-sizing: border-box;\n}\n\n.ind-container .ind-list-header .ind-list-name,\n.ind-container .ind-list-header .ind-list-perf {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.ind-container .ind-list-header .ind-list-perf {\n  justify-content: flex-end;\n}\n\n.ind-container .ind-list-name.sortable,\n.ind-container .ind-list-perf.sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.ind-container .ind-list-name.sortable svg,\n.ind-container .ind-list-perf.sortable svg {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 4px;\n  transition: transform 0.2s ease;\n}\n\n.ind-container .ind-list-body .ind-list-row:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.ind-container .ind-list-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 40px;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.ind-container .ind-list-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.ind-container .ind-list-ctry {\n  flex: none;\n  display: inline-flex;\n}\n\n.ind-container .ind-list-ctry svg {\n  width: 20px;\n  height: 20px;\n}\n\n.ind-container .ind-list-name {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  text-align: left;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: var(--text-ticker);\n  cursor: pointer;\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.ind-container .ind-list-name .ind-tbl-cel-flex-container {\n  max-width: 100%;\n  width: 100%;\n}\n\n.ind-container .ind-list-name.highlighted {\n  font-weight: bold !important;\n}\n\n.ind-container .ind-list-perf {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  flex: none;\n}\n\n.ind-container .ind-list-perf.nochange {\n  color: var(--text-unchg-color);\n}\n\n.ind-container .ind-list-perf.positive {\n  color: var(--text-up-color);\n}\n\n.ind-container .ind-list-perf.negative,\n.ind-container .ind-list-perf.negative-small {\n  color: var(--text-down-color);\n}\n\n.ind-container .ind-list-no-data {\n  padding: 16px 8px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.ind-container .ind-list-footer {\n  padding: 16px 8px;\n  text-align: left;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
